import { AutogenModelAuditLogTx, AutogenRowAuditLogTx } from "./autogen/AutogenModelAuditLogTx";

export class ModelAuditLogTx extends AutogenModelAuditLogTx<RowAuditLogTx> {
	constructor() {
		super(RowAuditLogTx);
	}
}

export class RowAuditLogTx extends AutogenRowAuditLogTx {
}